import React from "react";

const FoundersPerspective = ({
  founderImage,
  founderImageAlt = "Founder",
  povImage,
  povImageAlt = "Office",
  founderRole = "Founder & CEO",
  founderName = "PRADIP PARIDA",
  quote = "A world where every care journey is connected, intelligent, and continuous.",
  description = "",
  povTitle = "Our POV",
  povParagraphs = [],
}) => {
  return (
    <section
      className="w-full py-10 md:py-14 lg:py-16"
      style={{ backgroundColor: "#f0f4ff" }}
    >
      <div className="container-fluid">
        {/* 60 / 40 grid with a visible gap between panels */}
        <div
          className="grid grid-cols-1 lg:grid-cols-5 gap-6"
          style={{ alignItems: "stretch" }}
        >
          {/* ══════════════════════════════
              LEFT PANEL  — col-span-3 (60%)
          ══════════════════════════════ */}
          <div
            className="lg:col-span-3 relative rounded-2xl overflow-hidden"
            style={{ minHeight: "420px" }}
          >
            {/* Watermark — sized to fit fully within this panel */}
            <div
              className="absolute inset-x-0 top-0 pointer-events-none select-none overflow-hidden"
              aria-hidden="true"
            >
              <p
                className="font-black uppercase whitespace-nowrap leading-none"
                style={{
                  fontSize: "clamp(1.3rem, 3.5vw, 3.2rem)",
                  color: "var(--primary-color)",
                  opacity: 0.12,
                  letterSpacing: "0.04em",
                  paddingLeft: "1.3rem",
                  paddingTop: "0.5rem",
                }}
              >
                Founder's Perspective
              </p>
            </div>

            {/* Card content */}
            <div
              className="relative p-6 md:p-8 h-full flex flex-col"
              style={{ zIndex: 1 }}
            >
              {/* Spacer to sit content below watermark */}
              <div style={{ marginTop: "clamp(1.8rem, 3.5vw, 3.2rem)" }}>
                {/* Role */}
                <p
                  className=" font-medium mb-1"
                  style={{ color: "var(--text-light)" }}
                >
                  {founderRole}
                </p>

                {/* Name */}
                <h2 className="font-black tracking-wide mb-5 ">
                  {founderName}
                </h2>

                {/* Quote row: text left, founder image right bottom-aligned */}
                <div className="flex flex-col md:flex-row md:items-end gap-6 md:gap-4">
                  {/* Quote + description */}
                  <div className="flex-1 min-w-0">
                    {/* Opening quote mark */}
                    <span
                      className="block font-black leading-none mb-1 text-3xl md:text-[2rem]"
                      style={{
                        color: "var(--primary-color)",
                        opacity: 0.35,
                      }}
                      aria-hidden="true"
                    >
                      &ldquo;
                    </span>

                    <blockquote
                      className="font-semibold leading-snug mb-3 "
                      style={{ color: "var(--text-dark)" }}
                    >
                      {quote}
                    </blockquote>

                    {description && (
                      <p className="leading-relaxed">
                        {description}
                      </p>
                    )}

                    {/* Closing quote mark */}
                    <span
                      className="block text-right font-serif font-black leading-none mt-3 text-3xl md:text-[2rem]"
                      style={{
                        color: "var(--primary-color)",
                        opacity: 0.35,
                      }}
                      aria-hidden="true"
                    >
                      &rdquo;
                    </span>
                  </div>

                  {/* Founder image */}
                  {founderImage && (
                    <div
                      className="
        w-full 
        md:w-[clamp(120px,13vw,185px)] 
        flex justify-center md:justify-end
      "
                    >
                      <img
                        src={founderImage}
                        alt={founderImageAlt}
                        className="
          w-[140px] sm:w-[160px] md:w-full 
          h-auto object-contain object-bottom
        "
                        draggable={false}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ══════════════════════════════
              RIGHT PANEL — col-span-2 (40%)
          ══════════════════════════════ */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden flex flex-col">
            <div className="p-6 md:p-8 flex flex-col gap-4 h-full">
              <h3 className="font-bold ">
                {povTitle}
              </h3>

              <div className="flex flex-col gap-3">
                {povParagraphs.map((para, i) => (
                  <p
                    key={i}
                    className="leading-relaxed"
                    style={{ color: "var(--text-dark)" }}
                  >
                    {para}
                  </p>
                ))}
              </div>

              {povImage && (
                <div className="mt-auto rounded-xl overflow-hidden">
                  <img
                    src={povImage}
                    alt={povImageAlt}
                    className="w-full h-44 md:h-52 object-cover object-center"
                    draggable={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersPerspective;
